export default "/_next/static/chunks/fonts/Roboto-a8d6ac03c7b96b7acb6228ff2676139d.ttf";